import React from "react";
import "./PrimaryButton.css";

export default function PrimaryButton({
  title,
  onClick,
  loading = false,
  disabled = false,
  type = "button",
  fullWidth = false,   // ✅ تمام عرض
  icon = null          // ✅ آیکن اختیاری
}) {
  return (
    <button
      type={type}
      className={`primary-button
                  ${loading ? "is-loading" : ""}
                  ${fullWidth ? "full-width" : ""}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <span className="spinner"></span>
      ) : (
        <>
          {icon && <span className="btn-icon">{icon}</span>}
          <span className="btn-title">{title}</span>
        </>
      )}
    </button>
  );
}
